'use strict';
var Facebook;

Facebook = {
  init: function(signinFlyout) {
    if (!$('#ls-btn-facebook').length) {
      return;
    }
    this.signinFlyout = signinFlyout;
    $('#ls-btn-facebook').on('click', (function(_this) {
      return function() {
        return _this.signIn();
      };
    })(this));
    $('#signin-flyout-fb-reauth').on('click', (function(_this) {
      return function() {
        GIG.Modal.close();
        return _this.signIn(true);
      };
    })(this));
    return $('#signin-flyout-reauth-modal-close-button').on('click', function() {
      return GIG.Modal.close();
    });
  },
  signIn: function(reauth) {
    var option;
    if (reauth == null) {
      reauth = false;
    }
    $('#ls-signin-error').text('').hide();
    option = {
      scope: 'email,user_friends,user_hometown',
      return_scopes: true
    };
    if (reauth) {
      Object.assign(option, {
        auth_type: 'rerequest'
      });
    }
    return FB.login((function(_this) {
      return function(res) {
        if ((res != null ? res.status : void 0) === 'connected') {
          return _this.loginOrConnect(res);
        } else {
          return _this.onError('facebook_side_error');
        }
      };
    })(this), option);
  },
  loginOrConnect: function(res) {
    var grantedScopes;
    if (res != null ? res.authResponse : void 0) {
      grantedScopes = res.authResponse.grantedScopes;
      if ((grantedScopes != null ? grantedScopes.indexOf('email') : void 0) > -1) {
        return FB.api('/me', {
          fields: 'id,name,email,first_name,last_name,picture.type(square)'
        }, (function(_this) {
          return function(userInfo) {
            return _this.save(res, userInfo);
          };
        })(this));
      } else {
        return GIG.Modal.open({
          id: 'ls-signin-flyout-reauth-modal'
        });
      }
    } else {
      return this.onError();
    }
  },
  save: function(res, userInfo) {
    var $csrf, accessToken, data, ref, signedRequest;
    ref = res.authResponse, accessToken = ref.accessToken, signedRequest = ref.signedRequest;
    $csrf = $("input[name='_csrf']");
    data = {
      _csrf: ($csrf != null ? typeof $csrf.val === "function" ? $csrf.val() : void 0 : void 0) || '',
      access_token: accessToken,
      signed_request: signedRequest,
      email: userInfo.email,
      remember_me: !!$('#ls-remember-me').prop('checked')
    };
    return $.ajax({
      type: 'POST',
      url: '/facebook',
      data: data,
      success: (function(_this) {
        return function(resData) {
          var redirectUrl;
          _this.signinFlyout.successMetric();
          redirectUrl = (resData != null ? resData.location : void 0) || window.location.href;
          return window.location.href = redirectUrl;
        };
      })(this),
      error: (function(_this) {
        return function(errMsg) {
          return _this.onError(errMsg);
        };
      })(this)
    });
  },
  onError: function() {
    return $('#ls-signin-error').text(Groupon.LS.translations.userNav.signInflyoutUnknownError).show();
  }
};

module.exports = Facebook;

